import styled from 'styled-components';

import { Flex, fromTheme } from '@aircall/tractor';

export const ActionBar = styled(Flex)`
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 16px;
  border-top: 1px solid ${fromTheme('colors.grey.base')};
  will-change: transform;
`;
